// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"215c3f6c","86":"b50011ad","155":"7748d852","349":"93b73a19","400":"6b6cf516","423":"c9fd56ac","583":"29658836","918":"aac92de6","951":"106f79a3"}[chunkId] + ".chunk.css";
};